module.exports = __webpack_public_path__ + "img/MirageCH.e3cbdb95.jpg";